import { useRef, useState } from "react";
import "../Styles/Contact.css";
import CustomComponents from "../Components/Styled/Components";
import Map from "../Components/Map/Map";
import { useFormik } from "formik";
import * as Yup from "yup";
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const { StyledButton, StyledForm, StyledInput, StyledTextArea } =
    CustomComponents;

  const formRef = useRef(null);
  const serviceId = "service_cmxq6x8";
  const templateId = "template_dpeoovj";
  const publicKey = "AGKIxHXVN4xmm_kxe";

  const ContactFormSchema = Yup.object().shape({
    firstname: Yup.string().required("Please enter your first name"),
    lastname: Yup.string().required("Please enter your last name"),
    email: Yup.string()
      .required("Please enter your email")
      .email("Please enter a valid email"),
    phone: Yup.string().required("Please enter your phone number"),
    message: Yup.string().required("Please type a message here"),
  });

  const options = {
    theme: "colored",
    position: "top-center",
    autoClose: false,
  };
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, [])

  async function sendMessage(values) {
    try {
      let res = await emailjs.sendForm(
        serviceId,
        templateId,
        formRef.current,
        publicKey
      );
      toast.success("Message sent successfully", { ...options });
      console.log(res);
    } catch (error) {
      toast.error("Someting went wrong" + error.message, { ...options });
    } finally {
      setLoading(false);
    }
  }

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      message: "",
    },
    onSubmit: (values) => {
      console.log(values);
      setLoading(true);
      sendMessage(values);
    },
    validationSchema: ContactFormSchema,
  });

  return (
    <>
      <ToastContainer />
      <div className="contact text-center">
        <div className="contact-container mx-auto">
          <h1 className="fs-1 fw-bolder">Contact Us</h1>
          <div className="mt-4 pt-3 ">
            <p className="mb-1 fw-bold">Office Address:</p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
          <div className="mt-4 pt-3">
            <p className="fw-bold mb-1">Email:</p>
            <p>support@2mseamless.com</p>
          </div>
          <div className="mt-4 pt-3">
            <p className="fw-bold mb-1">Help Line:</p>
            <p>+234 810 002 0000</p>
          </div>
          <StyledForm ref={formRef} onSubmit={formik.handleSubmit}>
            <p className="fw-bold fs-3 mb-1">We'd love to hear from you</p>
            <p>
              Our friendly team would love to attend to your questions as fast
              as possible!
            </p>
            <div className="d-grid gap-4 pt-3">
              <div className="d-flex flex-column flex-sm-row gap-4 gap-sm-0 justify-content-between">
                <div className="input-container">
                  <StyledInput
                    placeholder="First name"
                    className="d-block  text-primary fw-bold"
                    name="firstname"
                    {...formik.getFieldProps("firstname")}
                  />
                  {formik.touched.firstname && formik.errors.firstname && (
                    <span className="text-xs">{formik.errors.firstname}</span>
                  )}
                </div>
                <div className="input-container">
                  <StyledInput
                    placeholder="Last name"
                    className="d-block col-sm-6 text-primary fw-bold"
                    name="lastname"
                    {...formik.getFieldProps("lastname")}
                  />
                  {formik.touched.lastname && formik.errors.lastname && (
                    <span className="text-xs">{formik.errors.lastname}</span>
                  )}
                </div>
              </div>
              <div className="d-flex flex-column flex-sm-row gap-4 gap-sm-0 justify-content-between">
                <div className="input-container">
                  <StyledInput
                    placeholder="Email"
                    className="d-block col-sm-6 text-primary fw-bold"
                    name="email"
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <span className="text-xs">{formik.errors.email}</span>
                  )}
                </div>
                <div className="input-container">
                  <StyledInput
                    placeholder="Phone number"
                    className="d-block col-sm-6 text-primary fw-bold"
                    name="phone"
                    {...formik.getFieldProps("phone")}
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <span className="text-xs">{formik.errors.phone}</span>
                  )}
                </div>
              </div>
              <div className="d-flex flex-column">
                <StyledTextArea
                  className=""
                  name="message"
                  {...formik.getFieldProps("message")}
                />
                {formik.touched.message && formik.errors.message && (
                  <span className="text-xs">{formik.errors.message}</span>
                )}
              </div>
              <StyledButton
                disabled={loading}
                type="submit"
                className={`${loading && "loading-button"} mx-auto`}
              >
                <span>Send Message</span>
                {loading && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                )}
              </StyledButton>
            </div>
          </StyledForm>
        </div>
        <div className="location text-center pb-5 mb-5">
          <p className="fs-3 fw-bold mb-2">Location</p>
          <Map />
        </div>
      </div>
    </>
  );
};

export default Contact;
